import addOneLog from "features/panelManagement/logging/actions/set.addOneLog";
import extractCombinedTagKeysFromProduct from "features/product/functions/extractCombinedTagKeysFromProduct";
import batchOperations from "services/firebase/batchOperations";

import { AppThunk } from "services/redux/rootReducer";
import { Product } from "../../types/product";

const addManyProducts =
    (products: Product[]): AppThunk =>
    async (dispatch) => {
        await batchOperations(async (batch, db, batchedProducts) => {
            await Promise.all(
                batchedProducts.map(async (product) => {
                    const docRef = db.collection("products").doc(product.id);
                    const subCollectionRef = docRef.collection("tables");

                    let tableIds: string[] = [];

                    // add tables to subcollections
                    await Promise.all(
                        Object.values(product.tables).map(async (table) => {
                            const docRef = subCollectionRef.doc();
                            await docRef.set({
                                ...table,
                                id: docRef.id,
                            });
                            tableIds.push(docRef.id);
                        })
                    );

                    const combinedTags =
                        extractCombinedTagKeysFromProduct(product);

                    // remove property tables from product object
                    const { tables, ...productWithoutTables } = product;

                    batch.set(docRef, {
                        ...productWithoutTables,
                        properties: {
                            ...productWithoutTables.properties,
                            creationTimestamp: Date.now(),
                            updateTimestamp: Date.now(),
                        },
                        tableIds,
                        combinedTags,
                    } as Product);
                }) 
            );
        }, products);

        dispatch(
            addOneLog({
                eventInfo: {
                    description: `Added multiple product(s) with id(s) ${products
                        .map((product) => product.id)
                        .join(", ")}`,
                },
            })
        );

        return;
    };

export default addManyProducts;
